import React from 'react';
import { motion } from 'framer-motion'

/**
 * The `AnimatedButton` component is a React component that renders a div with animation effects when
 * hovered over.
 * @returns a JSX element. Specifically, it is returning a `<motion.div>` element from the Framer
 * Motion library.
 */
export default function AnimatedButton({children, disabled, className, id, handleClick, style}) {
    return(
        <motion.button
            disabled={disabled}
            data-testid={id}
            id={id}
            type="button"
            className={`rounded-[49px] border border-[#797979] items-center flex blue-shadow disabled:pointer-events-none disabled:opacity-50 ${className ? className : ''}`}
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.2 }}
            onClick={() => handleClick() || ''}
            style={style}
        >
            {children}
        </motion.button>
    )
}